import { createContext, useState } from "react";

export const AddressFormContext = createContext();
export const AddressFormProvider = ({ children }) => {
  const [addressForm, setAddressForm] = useState();
  const updateAddressForm = (data) => {
    setAddressForm(data);
  };
  return (
    <AddressFormContext.Provider value={{ addressForm, updateAddressForm }}>
      {children}
    </AddressFormContext.Provider>
  );
};
